'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _utils = require('helpers/utils');

require('./SwitherDescription.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    SwitcherDescription: {
        displayName: 'SwitcherDescription'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/SHARE/SwitherDescription/SwitcherDescription.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var SwitcherDescription = _wrapComponent('SwitcherDescription')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(SwitcherDescription, _Component);

    function SwitcherDescription(props) {
        (0, _classCallCheck3.default)(this, SwitcherDescription);

        var _this = (0, _possibleConstructorReturn3.default)(this, (SwitcherDescription.__proto__ || (0, _getPrototypeOf2.default)(SwitcherDescription)).call(this, props));

        _this.onClick = function () {
            return _this.setState(function (prevState) {
                return {
                    short: !prevState.short
                };
            });
        };

        _this.state = {
            short: true
        };
        return _this;
    }

    (0, _createClass3.default)(SwitcherDescription, [{
        key: 'render',
        value: function render() {
            var short = this.state.short;
            var description = this.props.description;


            return _react3.default.createElement(
                'div',
                { className: 'brand' },
                _react3.default.createElement('div', {
                    className: 'brand__short' + (short ? '_is-active' : '') + ' ',
                    dangerouslySetInnerHTML: { __html: (0, _utils.stripTags)(description) },
                    onClick: this.onClick
                }),
                _react3.default.createElement('div', {
                    className: 'brand__full' + (short ? '' : '_is-active') + ' ',
                    dangerouslySetInnerHTML: { __html: description },
                    onClick: this.onClick
                })
            );
        }

        /**
         * Обработчик клика по тексту
         */

    }]);
    return SwitcherDescription;
}(_react2.Component), _class.defaultProps = {
    description: ''
}, _class.propTypes = {
    description: _react2.PropTypes.string
}, _temp));

exports.default = SwitcherDescription;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SHARE/SwitherDescription/SwitcherDescription.jsx
// module id = 1759
// module chunks = 0